module.exports = __webpack_public_path__ + "img/red_067.067b618b.png";